import React,{Fragment}from'react';import PropTypes from'prop-types';/**
 * A placeholder for a translation key.
 * @param {Object} props The component props.
 * @param {Object} context The component context.
 * @returns {JSX}
 */var Placeholder=function Placeholder(props){return React.createElement(Fragment,null,props.children);};Placeholder.format=function(props){return React.createElement(Placeholder,props);};export default Placeholder;